export default [
  {
    'projectId':'94346281c4ad4938b7d0ae6fa9899bec',
    'transcriptId':'19cjw29xii80000ird74yb19swa',
    'start':246.58,
    'end':249.34,
    'labelId':'cb10e79c20af4a7f8b3fe8a4c789d43e',
    'note':'example note on this annotation',
    '_id':'72d4ac9d0f16481eac83946a0384d12d',
    'id':'72d4ac9d0f16481eac83946a0384d12d'
  },
  {
    'projectId':'94346281c4ad4938b7d0ae6fa9899bec',
    'transcriptId':'19cjw29xii80000ird74yb19swa',
    'start':585.66,
    'end':596.03,
    'labelId':'cb10e79c20af4a7f8b3fe8a4c789d43e',
    'note':'',
    '_id':'4de867b1f8694235b01f64e4b5628cc1'
  },
  {
    'projectId':'94346281c4ad4938b7d0ae6fa9899bec',
    'transcriptId':'19cjw29xii80000ird74yb19swa',
    'start':13.86,
    'end':19.58,
    'labelId':'cb10e79c20af4a7f8b3fe8a4c789d43e',
    'note':'',
    '_id':'ac440b482b5842a2aa36050ed74cc132'
  },
  {
    'projectId':'94346281c4ad4938b7d0ae6fa9899bec',
    'transcriptId':'29cjw29xii80000ird74yb19swa',
    'start':19.3,
    'end':24.3,
    'labelId':'920fa8f97acc43b5bc0694b2e5648080',
    'note':'',
    '_id':'9d78e7fa69274497956f2efbd39351c6'
  },
  {
    'projectId':'94346281c4ad4938b7d0ae6fa9899bec',
    'transcriptId':'19cjw29xii80000ird74yb19swa',
    'start':116.26,
    'end':122.62,
    'labelId':'default',
    'note':'',
    '_id':'c75da56b01aa4f2ab571abcec8b9da92'
  },
  {
    'projectId':'10046281c4ad4938b7d0ae6fa9899bec',
    'transcriptId':'1000cjw29xii80000ird74yb19swa',
    'start':9.48,
    'end':13.72,
    'labelId':'default',
    'note':'',
    '_id':'00dd43dbcdd8419e9177784158aac9fa'
  },
  {
    'projectId':'94346281c4ad4938b7d0ae6fa9899bec',
    'transcriptId':'19cjw29xii80000ird74yb19swa',
    'start':109.41,
    'end':119.2,
    'labelId':'default',
    'note':'',
    '_id':'1de06f64ea5a4dd4a7f4b68dfb917d53'
  },
  {
    'projectId':'94346281c4ad4938b7d0ae6fa9899bec',
    'transcriptId':'19cjw29xii80000ird74yb19swa',
    'start':366.26,
    'end':368.95,
    'labelId':'cb10e79c20af4a7f8b3fe8a4c789d43e',
    'note':'',
    '_id':'ef8a71a6ec684c9295b97ded19ebd383'
  },
  {
    'projectId':'94346281c4ad4938b7d0ae6fa9899bec',
    'transcriptId':'19cjw29xii80000ird74yb19swa',
    'start':55.36,
    'end':66.47,
    'labelId':'920fa8f97acc43b5bc0694b2e5648080',
    'note':'',
    '_id':'5c48fb82cfa9416baf480b5bab432521'
  },
  {
    'projectId':'94346281c4ad4938b7d0ae6fa9899bec',
    'transcriptId':'19cjw29xii80000ird74yb19swa',
    'start':89.86,
    'end':101.84,
    'labelId':'920fa8f97acc43b5bc0694b2e5648080',
    'note':'',
    '_id':'139d1ecc3c1c496892955cab9d8d0714'
  },
  {
    'projectId':'94346281c4ad4938b7d0ae6fa9899bec',
    'transcriptId':'19cjw29xii80000ird74yb19swa',
    'start':86.66,
    'end':100.87,
    'labelId':'db055983fabd40ef84dc35fbd3dfb40b',
    'note':'',
    '_id':'2a3e18369d9f497289730ad291ba34b8'
  }
];
